import { useTranslation } from 'react-i18next'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import { useFetchCustomerCoupons } from '@entities/Loyalty/hooks/useFetchCustomerCoupons'

import Wrapper from '@shared/ui/wrapper'

import Item from './CouponItem'

import styles from './styles.module.scss'

export default function PersonalCoupons () {
  const { t: tn } = useTranslation('personal')
  const isTablet = useMediaQuery('(max-width: 768px)')
  const { coupons, loading } = useFetchCustomerCoupons()

  if (loading || !coupons?.length) {
    return null
  }
  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <div className={styles.root__content}>
          <h2 className={styles.root__title}>{tn('coupons.title')}</h2>
          <Swiper
            className={styles.swiper}
            spaceBetween={12}
            modules={[ Navigation ]}
            navigation={!isTablet}
            breakpoints={{
              768: {
                spaceBetween: 24,
              },
            }}
            slidesPerView={'auto'}
          >
            {coupons.map((coupon) => (
              <SwiperSlide className={styles.slide} key={coupon.id}>
                <Item
                  title={coupon.localInfo?.title || coupon.name}
                  description={coupon.localInfo?.shortDescription || ''}
                  validTo={coupon.localInfo?.validTo || coupon.validTo || undefined}
                  imageUrl={coupon.localInfo?.imageUrl}
                  canBeActivated={coupon.localInfo?.canBeActivated}
                  qrCode={coupon.qrCode}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </Wrapper>
    </div>
  )
}
